import { useState, useEffect } from 'react';
import { authAPI } from './api';
export function useAuth() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        checkAuth();
    }, []);
    const checkAuth = async () => {
        try {
            const data = await authAPI.me();
            setUser(data.user);
        }
        catch (error) {
            setUser(null);
        }
        finally {
            setLoading(false);
        }
    };
    const login = async (email, password) => {
        const data = await authAPI.login(email, password);
        // Store token in localStorage for cross-domain scenarios
        if (data.token) {
            localStorage.setItem('auth_token', data.token);
        }
        setUser(data.user);
        return data;
    };
    const logout = async () => {
        await authAPI.logout();
        localStorage.removeItem('auth_token');
        setUser(null);
    };
    return { user, loading, login, logout, checkAuth };
}
